<template>
    <div cla>
      <Modal aria="false"  :style-class="visible ? 'display: block;' : 'display: none;'">
        <template v-slot:content>
          <div class="container_content">
            <img src="@/assets/warning.svg" alt="">
            <p class="container_title">Are you sure you want to reverse the selected transactions ({{ transactions.length }})?</p>
            <div class="btns">
              <div class="close_btn" @click="closeModal">Cancel</div>
              <div class="confirm_btn" :class="{ loading: loading }" @click="!loading ? confirmUpdate() : null">
                Confirm
              </div>
            </div>
          </div>
        </template>
      </Modal  ncknkdvn>
    </div>
  </template>
  
  <script>
  import Modal from "@/components/modalv2.vue";
  import WovenStrip from "@/components/wovenstrip.vue";
  
  export default {
    name: "ExtendModal",
  
    components: {
      Modal,
      WovenStrip,
    },
  
    computed: {
    visible() {
      return this.transactions.length > 0;
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        // Force modal to show when visible becomes true
        this.$nextTick(() => {
          const modalElement = document.querySelector('.modal');
          if (modalElement) {
            modalElement.classList.add('show');
            modalElement.style.display = 'block';
          }
        });
      }
    }
  },

    props: {
      transactions: {
        type: Array,
        required: true,
      },
    },
  
    data() {
      return {
        loading: false,
        currentStatus: "active", 
        transactionDetails: null,
      };
    },
  
    methods: {
      handleStatusChange(event) {
        this.currentStatus = event.target.value;
      },
  
      closeModal() {
        this.$emit("hide");
      },
      completed() {
        this.$emit("completed");
      },
      completedWithErrors() {
        this.$emit("completedWithErrors");
      },
  
      async confirmUpdate() {
        this.loading = true;
        const transactionIds = this.transactions.map((transaction) => transaction.nip_session_id || transaction.unique_reference)
        const errors = [];

            const requestBody = {
              nip_session_ids: transactionIds,
            };
            await this.$http.post("admin/reversal/bulk", requestBody)
                .then((response) => {})
                .catch((error) => {
                  errors.push(error);
                });
  
        if(errors.length > 0){
            console.log(errors);
            this.$emit("completedWithErrors", errors);
        }else{
            this.$emit("completed");
        }
        this.loading = false;
        this.closeModal(); 
      },
    },
  };
  </script>
  
  <style lang="scss">
  .container_content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 20px;
    width: 100%;
    margin: 20px auto;
  }
  .options_header{
      width: 100%;
      display: grid;
      grid-template-columns: 1fr;
      gap: 20px;
      justify-content: space-between;
      align-items: center;
      justify-content: center;
      text-align: center;
      select{
          width: 300px;
          height: 44px;
          border: 1px solid #D5D7DA;
          border-radius: 8px;
          justify-self: center;
          padding: 10px;
          option{
              width: 100%;
          }
      }
  }
  .btns{
      display: flex;
      align-items: center;
      gap: 32px;
      width: 100%;
      justify-content: space-between;
  }
  .confirm_btn, .close_btn {
    font-family: Lato;
    font-size: 16px;
    font-weight: 500;
    line-height: 16px;
    text-align: center;
    background-color: #E00B5B;
    border-radius: 6px;
    border-style: none;
    box-sizing: border-box;
    color: #FFFFFF;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 500;
    height: 48px;
    width: 100%;
  }
  .close_btn{
      color: black !important;
      background-color: white !important;
      border: 1px solid #848688;
      color: #848688 !important;
  }
  .modal-content{
      border-radius: 16px !important;
      max-width: 700px !important;
      padding-left: 5% !important;
      padding-right: 5% !important;
  }
  .container_title{
    font-size: 30px;
    font-weight: 600;
    text-align: center;
  }
  .loading{
    opacity: 0.5;
  }
  </style>